// extracted by mini-css-extract-plugin
module.exports = {"carouselArrow":"c_rYEhd","smallArrows":"c9KmouX","carouselArrowLeft":"bXe23-","smallArrowSpacing":"myFgYC","carouselArrowRight":"q9qVG0","rootIcon":"KlN14B","smallArrow":"oy8q27"};